import { render, staticRenderFns } from "./EditZona.vue?vue&type=template&id=1b45ed78"
import script from "./EditZona.vue?vue&type=script&lang=js"
export * from "./EditZona.vue?vue&type=script&lang=js"
import style0 from "./EditZona.vue?vue&type=style&index=0&id=1b45ed78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports